import reducer, {
    setUsedInMeshbotsLoading,
    setUsedInMeshbotsError,
    setHasOfflineControllers,
    setCloudUsedLocations,
    setLocalUsedLocations,
} from '../geofenceSettings';

const INITIAL_USED_IN_MESHBOTS = {
    isLoading: false,
    error: null,
    hasOfflineControllers: false,
    locations: {
        cloud: [],
        local: [],
    },
};

describe('geofenceSettings reducer — usedInMeshbots', () => {
    describe('initialState', () => {
        it('should have usedInMeshbots field with correct default values', () => {
            const state = reducer(undefined, { type: '@@INIT' });

            expect(state.usedInMeshbots).toEqual(INITIAL_USED_IN_MESHBOTS);
        });

        it('should preserve existing fields: geofenceLocations and geofenceRegisteredDevices', () => {
            const state = reducer(undefined, { type: '@@INIT' });

            expect(state).toHaveProperty('geofenceLocations', null);
            expect(state).toHaveProperty('geofenceRegisteredDevices', null);
        });
    });

    describe('setUsedInMeshbotsLoading', () => {
        it('should set isLoading to true', () => {
            const state = reducer(undefined, setUsedInMeshbotsLoading(true));

            expect(state.usedInMeshbots.isLoading).toBe(true);
        });

        it('should set isLoading to false', () => {
            const stateWithLoading = reducer(undefined, setUsedInMeshbotsLoading(true));
            const state = reducer(stateWithLoading, setUsedInMeshbotsLoading(false));

            expect(state.usedInMeshbots.isLoading).toBe(false);
        });

        it('should not affect other usedInMeshbots fields', () => {
            const state = reducer(undefined, setUsedInMeshbotsLoading(true));

            expect(state.usedInMeshbots.error).toBe(null);
            expect(state.usedInMeshbots.hasOfflineControllers).toBe(false);
            expect(state.usedInMeshbots.locations).toEqual({ cloud: [], local: [] });
        });
    });

    describe('setUsedInMeshbotsError', () => {
        it('should set error message string', () => {
            const errorMessage = 'Failed to fetch scenes';
            const state = reducer(undefined, setUsedInMeshbotsError(errorMessage));

            expect(state.usedInMeshbots.error).toBe(errorMessage);
        });

        it('should clear error when null is passed', () => {
            const stateWithError = reducer(undefined, setUsedInMeshbotsError('some error'));
            const state = reducer(stateWithError, setUsedInMeshbotsError(null));

            expect(state.usedInMeshbots.error).toBe(null);
        });

        it('should not affect other usedInMeshbots fields', () => {
            const state = reducer(undefined, setUsedInMeshbotsError('error'));

            expect(state.usedInMeshbots.isLoading).toBe(false);
            expect(state.usedInMeshbots.hasOfflineControllers).toBe(false);
            expect(state.usedInMeshbots.locations).toEqual({ cloud: [], local: [] });
        });
    });

    describe('setHasOfflineControllers', () => {
        it('should set hasOfflineControllers to true', () => {
            const state = reducer(undefined, setHasOfflineControllers(true));

            expect(state.usedInMeshbots.hasOfflineControllers).toBe(true);
        });

        it('should set hasOfflineControllers to false', () => {
            const stateWithOffline = reducer(undefined, setHasOfflineControllers(true));
            const state = reducer(stateWithOffline, setHasOfflineControllers(false));

            expect(state.usedInMeshbots.hasOfflineControllers).toBe(false);
        });

        it('should not affect other usedInMeshbots fields', () => {
            const state = reducer(undefined, setHasOfflineControllers(true));

            expect(state.usedInMeshbots.isLoading).toBe(false);
            expect(state.usedInMeshbots.error).toBe(null);
            expect(state.usedInMeshbots.locations).toEqual({ cloud: [], local: [] });
        });
    });

    describe('setCloudUsedLocations', () => {
        it('should set cloud locations array', () => {
            const uuids = ['uuid-1', 'uuid-2', 'uuid-3'];
            const state = reducer(undefined, setCloudUsedLocations(uuids));

            expect(state.usedInMeshbots.locations.cloud).toEqual(uuids);
        });

        it('should set cloud locations to empty array', () => {
            const stateWithData = reducer(undefined, setCloudUsedLocations(['uuid-1']));
            const state = reducer(stateWithData, setCloudUsedLocations([]));

            expect(state.usedInMeshbots.locations.cloud).toEqual([]);
        });

        it('should not affect local locations', () => {
            const stateWithLocal = reducer(undefined, setLocalUsedLocations(['local-uuid']));
            const state = reducer(stateWithLocal, setCloudUsedLocations(['cloud-uuid']));

            expect(state.usedInMeshbots.locations.local).toEqual(['local-uuid']);
        });

        it('should not affect other usedInMeshbots fields', () => {
            const state = reducer(undefined, setCloudUsedLocations(['uuid-1']));

            expect(state.usedInMeshbots.isLoading).toBe(false);
            expect(state.usedInMeshbots.error).toBe(null);
            expect(state.usedInMeshbots.hasOfflineControllers).toBe(false);
        });
    });

    describe('setLocalUsedLocations', () => {
        it('should set local locations array', () => {
            const uuids = ['uuid-a', 'uuid-b'];
            const state = reducer(undefined, setLocalUsedLocations(uuids));

            expect(state.usedInMeshbots.locations.local).toEqual(uuids);
        });

        it('should set local locations to empty array', () => {
            const stateWithData = reducer(undefined, setLocalUsedLocations(['uuid-a']));
            const state = reducer(stateWithData, setLocalUsedLocations([]));

            expect(state.usedInMeshbots.locations.local).toEqual([]);
        });

        it('should not affect cloud locations', () => {
            const stateWithCloud = reducer(undefined, setCloudUsedLocations(['cloud-uuid']));
            const state = reducer(stateWithCloud, setLocalUsedLocations(['local-uuid']));

            expect(state.usedInMeshbots.locations.cloud).toEqual(['cloud-uuid']);
        });

        it('should not affect other usedInMeshbots fields', () => {
            const state = reducer(undefined, setLocalUsedLocations(['uuid-a']));

            expect(state.usedInMeshbots.isLoading).toBe(false);
            expect(state.usedInMeshbots.error).toBe(null);
            expect(state.usedInMeshbots.hasOfflineControllers).toBe(false);
        });
    });

    describe('action creators', () => {
        it('setUsedInMeshbotsLoading creates correct action', () => {
            expect(setUsedInMeshbotsLoading(true)).toEqual({
                type: 'geofenceSettings/setUsedInMeshbotsLoading',
                payload: true,
            });
        });

        it('setUsedInMeshbotsError creates correct action', () => {
            expect(setUsedInMeshbotsError('error text')).toEqual({
                type: 'geofenceSettings/setUsedInMeshbotsError',
                payload: 'error text',
            });
        });

        it('setHasOfflineControllers creates correct action', () => {
            expect(setHasOfflineControllers(true)).toEqual({
                type: 'geofenceSettings/setHasOfflineControllers',
                payload: true,
            });
        });

        it('setCloudUsedLocations creates correct action', () => {
            expect(setCloudUsedLocations(['uuid-1'])).toEqual({
                type: 'geofenceSettings/setCloudUsedLocations',
                payload: ['uuid-1'],
            });
        });

        it('setLocalUsedLocations creates correct action', () => {
            expect(setLocalUsedLocations(['uuid-a'])).toEqual({
                type: 'geofenceSettings/setLocalUsedLocations',
                payload: ['uuid-a'],
            });
        });
    });
});
